"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var AutoComplete = require("react-autocomplete");
var Plus = require("react-icons/lib/md/add");
var react_redux_1 = require("react-redux");
var tasks_1 = require("../redux/tasks");
var Button_1 = require("./Button");
require("./style/TaskTags.css");
var TaskTag_1 = require("./TaskTag");
var TaskTags = /** @class */ (function (_super) {
    __extends(TaskTags, _super);
    function TaskTags() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { newTag: "", taggingTask: false };
        return _this;
    }
    TaskTags.prototype.render = function () {
        var _this = this;
        var _a = this.props, allTags = _a.allTags, currentItem = _a.currentItem, tags = _a.tags, updateCurrentItem = _a.updateCurrentItem;
        var _b = this.state, newTag = _b.newTag, taggingTask = _b.taggingTask;
        return (React.createElement("div", null,
            React.createElement("div", { className: "TaskTags-tags" },
                tags.map(function (tag, index) {
                    return React.createElement(TaskTag_1.default, { key: index, tag: tag, showRemoveButton: true, onClick: function () {
                            updateCurrentItem(__assign({}, currentItem, { tags: _.filter(tags, function (x) { return x !== tag; }) }));
                        } });
                }),
                React.createElement(Button_1.default, { style: taggingTask ? { display: "none" } : {}, className: "TaskTags-button", onClick: function () { return _this.setState({ taggingTask: true }); } },
                    React.createElement(Plus, null))),
            taggingTask &&
                React.createElement("form", { className: tags.length === 0 ? undefined : "TaskTags-margined-form", onSubmit: function (event) {
                        var tag = newTag.trim();
                        if (tag !== "" && !tags.includes(tag)) {
                            updateCurrentItem(__assign({}, currentItem, { tags: __spread(tags, [tag]).sort() }));
                        }
                        _this.setState({ taggingTask: false, newTag: "" });
                        event.preventDefault();
                    } },
                    React.createElement(AutoComplete, { getItemValue: function (tag) { return tag; }, items: _.difference(allTags, tags), renderItem: function (tag, highlighted) {
                            return React.createElement("div", { className: highlighted
                                    ? "TaskTags-tag-highlighted"
                                    : "TaskTags-tag" }, tag);
                        }, renderMenu: function (tags, currentTag) {
                            return React.createElement("div", { className: "TaskTags-suggestions", style: tags.length === 0 ? { display: "none" } : {} }, tags.map(function (item, index) {
                                return React.createElement("div", { key: index }, item);
                            }));
                        }, shouldItemRender: function (tag, input) {
                            return tag.toLowerCase().slice(0, input.length) === input.toLowerCase();
                        }, value: newTag, onChange: function (_a) {
                            var value = _a.target.value;
                            return _this.setState({ newTag: value });
                        }, onSelect: function (newTag) { return _this.setState({ newTag: newTag }); }, inputProps: {
                            autoFocus: true,
                            onBlur: function () { return _this.setState({ taggingTask: false }); },
                            placeholder: "tag name",
                        } }))));
    };
    return TaskTags;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var _b = _a.tasks, tags = _b.tags, rest = __rest(_b, ["tags"]);
    return (__assign({}, rest, { allTags: tags }));
}, tasks_1.actionCreators)(TaskTags);



//////////////////
// WEBPACK FOOTER
// ./src/component/TaskTags.tsx
// module id = 699
// module chunks = 0